export const apiUrl = process.env.REACT_APP_API_ENDPOINT || "";
export const apiKey = process.env.REACT_APP_API_KEY || "";
export const launchDarklyKey = process.env.REACT_APP_LAUNCH_DARKLY_KEY || "";
